export default function AboutTheFounder() {
    return (
        <>
            <section id="about-the-founder-section">
                <div className="founder-container">
                    <div className="founder-hero">
                        <div className="founder-hero-content">
                            <div className="founder-hero-image">
                                <div className="founder-image-wrapper">
                                    <img src="/images/about-the-founder.jpeg" alt="Harshita Rewadia - Founder" />
                                    <div className="founder-image-overlay">
                                        <div className="overlay-content">
                                            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                            </svg>
                                            <span>Opera Queen of India</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="founder-hero-text">
                                <div className="founder-badge">Founder & Visionary</div>
                                <h2 className="section-title">Harshita Rewadia</h2>
                                <p className="section-subtitle">The Opera Queen of India</p>
                                <p className="founder-hero-description">
                                    A trailblazer who has redefined the boundaries of music in India, Harshita Rewadia is the first Indian Ultra Soprano Opera Singer and the visionary founder of Harshita School of Music.
                                </p>
                                <div className="founder-stats">
                                    <div className="stat-item">
                                        <span className="stat-number">1st</span>
                                        <span className="stat-label">India's Ultra Soprano Opera Singer</span>
                                    </div>
                                    <div className="stat-item">
                                        <span className="stat-number">10+</span>
                                        <span className="stat-label">Teaching Experience</span>
                                    </div>
                                    <div className="stat-item">
                                        <span className="stat-number">20+</span>
                                        <span className="stat-label">Prestigious Awards</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="founder-vision-section">
                        <div className="vision-content">
                            <div className="vision-header">
                                <h3 className="vision-title">Her Vision & Mission</h3>
                            </div>
                            <div className="vision-text">
                                <p className="vision-paragraph">
                                    From a very young age, Harshita recognized the immense gap in India's music education—particularly in opera, western music, and other technically demanding disciplines. While talent was abundant, proper guidance, structured training, and deep technical knowledge were often missing.
                                </p>
                                <p className="vision-paragraph">
                                    It was this realization that sparked her vision: to build a music academy where excellence in every genre—be it opera, western vocals, Indian classNameical, or instrumental mastery—is nurtured with equal passion and precision. Thus, <strong>Harshita School of Music (HSM)</strong> was born: a place where students not only learn music but experience it as a journey of artistry, discipline, and transformation.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="founder-achievements-section">
                        <div className="achievements-header">
                            <h2 className="section-title">What Makes Her Truly Extraordinary</h2>
                            <p className="section-subtitle">A journey of groundbreaking achievements and pioneering contributions to music</p>
                        </div>

                        <div className="achievements-grid">
                            <div className="achievement-card">
                                <div className="achievement-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="achievement-content">
                                    <h4>India's First Ultra Soprano Opera Singer</h4>
                                    <p>A pioneering voice that reaches the rarest vocal registers ever achieved in India.</p>
                                </div>
                                <div className="achievement-badge">Pioneer</div>
                            </div>

                            <div className="achievement-card">
                                <div className="achievement-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="achievement-content">
                                    <h4>Titled as Opera Queen of India</h4>
                                    <p>Celebrated nationwide for redefining the boundaries of operatic singing.</p>
                                </div>
                            </div>

                            <div className="achievement-card">
                                <div className="achievement-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="achievement-content">
                                    <h4>Fame of India's Got Talent</h4>
                                    <p>Captivated millions as a trailblazing performance on the country’s biggest talent stage.</p>
                                </div>
                            </div>

                            <div className="achievement-card">
                                <div className="achievement-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="achievement-content">
                                    <h4>First to break Wine Glass by Voice</h4>
                                    <p>Demonstrated extraordinary vocal power on India's Got Talented by breaking glass by voice.</p>
                                </div>
                            </div>

                            <div className="achievement-card">
                                <div className="achievement-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="achievement-content">
                                    <h4>Multi Award Winning Artist</h4>
                                    <p>Honored with prestigious accolades celebrating her unique contribution to music.</p>
                                </div>
                            </div>

                            <div className="achievement-card">
                                <div className="achievement-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="achievement-content">
                                    <h4>Versatility Across Genres</h4>
                                    <p>Seamlessly masters Opera, Jazz, Bollywood, Western Contemporary, R&B & many other genres.</p>
                                </div>
                            </div>

                            <div className="achievement-card">
                                <div className="achievement-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="achievement-content">
                                    <h4>International Artist</h4>
                                    <p>Represents India on global platforms with mesmerizing cross-cultural performances.</p>
                                </div>
                            </div>

                            <div className="achievement-card">
                                <div className="achievement-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="achievement-content">
                                    <h4>Media Recognition</h4>
                                    <p>Featured in leading national and international media for her artistry.</p>
                                </div>
                            </div>

                            <div className="achievement-card">
                                <div className="achievement-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="achievement-content">
                                    <h4>Acclaimed Educator</h4>
                                    <p>A decade of experience mentoring aspiring vocalists with professional techniques.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="founder-awards-section">
                        <div className="awards-header">
                            <h2 className="section-title">Awards & Recognitions</h2>
                            <p className="section-subtitle">Celebrating her artistry, innovation, and contribution to music worldwide</p>
                        </div>

                        <div className="awards-showcase">
                            <div className="awards-grid">
                                <div className="award-card premium">
                                    <div className="award-icon">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                    <div className="award-content">
                                        <h4>Dadasaheb Phalke Film Festival Award</h4>
                                        <p>The first to achieve this award in Rajasthan, for her unparalleled contribution to music and performance.</p>
                                    </div>
                                    <div className="award-badge">First in Rajasthan</div>
                                </div>

                                <div className="award-card">
                                    <div className="award-icon">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                    <div className="award-content">
                                        <h4>Underground Paris Music Award</h4>
                                        <p>Honored internationally for her distinctive and powerful singing in her debut song "Jewels & Fame".</p>
                                    </div>
                                </div>

                                <div className="award-card">
                                    <div className="award-icon">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                    <div className="award-content">
                                        <h4>Women Achiever Award</h4>
                                        <p>Bestowed by Padma Shri Gulabo Sapera, celebrating her as a pioneering woman in the field of music.</p>
                                    </div>
                                </div>

                                <div className="award-card">
                                    <div className="award-icon">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                    <div className="award-content">
                                        <h4>Peace Through Music Award</h4>
                                        <p>Honored by the World Peace and Diplomacy Organisation for using her voice as a bridge of peace and unity.</p>
                                    </div>
                                </div>

                                <div className="award-card">
                                    <div className="award-icon">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                    <div className="award-content">
                                        <h4>International Stage Honor</h4>
                                        <p>Felicitated by Padma Bhushan & Grammy Award winner Pandit Vishnu Mohan Bhatt for her global impact on music.</p>
                                    </div>
                                </div>

                                <div className="award-card">
                                    <div className="award-icon">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                    <div className="award-content">
                                        <h4>Countrywide Impact Award</h4>
                                        <p>Felicitated by Bollywood singer Ankit Tiwari for being India's finest opera singer.</p>
                                    </div>
                                </div>

                                <div className="award-card">
                                    <div className="award-icon">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                    <div className="award-content">
                                        <h4>Rajasthan International Film Festival Award</h4>
                                        <p>For being Rajasthan's first Opera singer and growing it's culture in Rajasthan.</p>
                                    </div>
                                </div>

                                <div className="award-card">
                                    <div className="award-icon">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                    <div className="award-content">
                                        <h4>Mumbai International Film Festival Award</h4>
                                        <p>Honored nationwide distinctive and powerful singing in her debut song "Jewels & Fame".</p>
                                    </div>
                                </div>

                                <div className="award-card">
                                    <div className="award-icon">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                    <div className="award-content">
                                        <h4>Many More Awards</h4>
                                        <p>Recognized across national and international stages with numerous prestigious honors, celebrating her journey as one of the most powerful voices in contemporary music.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="founder-final-vision">
                        <div className="final-vision-content">
                            <div className="final-vision-header">
                                <h2 className="section-title">Vision as an Educator & Artist</h2>
                            </div>
                            <div className="final-vision-text">
                                <div className="vision-quote">
                                    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                                    </svg>
                                    <p>As an artist, Harshita's mission goes beyond performance. She envisions a world where music is not bound by geography or tradition but flows as a universal language of connection and empowerment.</p>
                                </div>

                                <div className="vision-paragraphs">
                                    <p>As an educator, she is deeply committed to bridging the gap in India's music education system. Through Harshita School of Music, her goal is to provide structured, high-quality training in both Indian and western disciplines—something she herself longed for during her own learning years.</p>

                                    <p>Her vision is to make international-standard education accessible to every aspiring musician while cultivating discipline, creativity, and professional excellence.</p>

                                    <p className="vision-conclusion">For Harshita, this school is more than an academy; it is her life's mission—to inspire, to uplift, and to ensure that every student not only learns music but also discovers their true voice and potential.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 